module.exports = __webpack_public_path__ + "img/frame17_normal.398fae6c.png";